import { DAY_LABELS } from "../lib/dates";
import { ALL_BLOCKS } from "../lib/blocks";
import { BRAND } from "../lib/brand";

/* ───────────────────── COACH CALENDAR MONTH ───────────────────── */
export function CoachCalendarMonth({ month, dateHeat, playerList, playerColorMap, selectedDay, onSelectDay }) {
  const startDay = new Date(month.year, month.month, 1).getDay();
  const totalPlayers = playerList.length;
  const cells = [];

  for (let i = 0; i < startDay; i++) cells.push(<div key={"e" + i} />);

  for (let d = 1; d <= month.days; d++) {
    const dk = month.year + "-" + String(month.month + 1).padStart(2, "0") + "-" + String(d).padStart(2, "0");
    const entries = dateHeat[dk] || [];
    // entries can be [{name, blocks}] (new) or ["name"] (legacy compat)
    const unavailCount = entries.length;
    const hasPartial = entries.some((e) => {
      if (typeof e === "object" && e.blocks) {
        const b = typeof e.blocks === "string" ? e.blocks.split(",") : e.blocks;
        return b.length > 0 && b.length < ALL_BLOCKS.length;
      }
      return false;
    });
    const availCount = totalPlayers - unavailCount;
    const ratio = totalPlayers > 0 ? availCount / totalPlayers : 1;
    const isSelected = selectedDay === dk;

    let bgColor, textColor, borderColor;
    if (totalPlayers === 0) {
      bgColor = "#f9fafb"; textColor = "#9ca3af"; borderColor = "#e5e7eb";
    } else if (ratio === 1) {
      bgColor = "#dcfce7"; textColor = "#166534"; borderColor = "#bbf7d0";
    } else if (ratio >= 0.75) {
      bgColor = "#ecfdf5"; textColor = "#065f46"; borderColor = "#d1fae5";
    } else if (ratio >= 0.5) {
      bgColor = "#fef9c3"; textColor = "#854d0e"; borderColor = "#fde68a";
    } else if (ratio > 0) {
      bgColor = "#fee2e2"; textColor = "#991b1b"; borderColor = "#fecaca";
    } else {
      bgColor = "#dc2626"; textColor = "#ffffff"; borderColor = "#b91c1c";
    }

    cells.push(
      <button
        key={d}
        onClick={() => onSelectDay(isSelected ? null : dk)}
        style={{ backgroundColor: bgColor, borderColor: isSelected ? BRAND.primary : borderColor, color: textColor }}
        className={"relative flex flex-col items-center justify-center aspect-square rounded-lg text-xs font-medium transition-all border-2 cursor-pointer " + (isSelected ? "ring-2 ring-blue-300 shadow-md" : "")}
      >
        <span className="font-bold text-sm leading-none">{d}</span>
        {totalPlayers > 0 && (
          <span className="text-[10px] leading-none mt-0.5 opacity-80">{availCount}/{totalPlayers}</span>
        )}
        {hasPartial && (
          <span className="absolute top-0 right-0.5 text-[9px] font-bold leading-none" style={{ color: textColor, opacity: 0.7 }}>½</span>
        )}
      </button>
    );
  }

  return (
    <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-4">
      <h3 className="text-center font-bold text-gray-800 mb-3">
        {month.name} {month.year}
      </h3>
      <div className="grid grid-cols-7 gap-1 mb-2">
        {DAY_LABELS.map((d) => (
          <div key={d} className="text-center text-xs font-medium text-gray-400 py-1">{d}</div>
        ))}
      </div>
      <div className="grid grid-cols-7 gap-1">{cells}</div>
    </div>
  );
}
